export default __webpack_public_path__ + "static/media/AVAXL.1d8f7c82.svg";